export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/6fGeJ17eRJGVHXyYUpHTMF/heylloyd-image-1784320666998.png'

export const HERO_BANNER_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/75d4985e-a464-4dbb-ab72-31bfd2320855.jpg'

export interface StyleConcept {
  imageUrl: string
  alt: string
  category: string
  label: string
  description: string
  accent: 'coral' | 'lime' | 'cobalt'
}

export const STYLE_CONCEPTS: readonly StyleConcept[] = [
  {
    imageUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/e25f2c4d-6962-4eca-8147-be6aecbef18b.jpg',
    alt: 'Concepto de web colorida para belleza y bienestar mostrado en un monitor',
    category: 'Beauty & wellness',
    label: 'Identidad que se reconoce',
    description: 'Color, estética y una experiencia que se siente completamente tuya.',
    accent: 'coral',
  },
  {
    imageUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/4f825c35-4b66-46e9-bacf-f795f64b9c70.jpg',
    alt: 'Concepto de web colorida para gastronomía y hospitalidad mostrado en una laptop',
    category: 'Food & hospitality',
    label: 'Reservas con personalidad',
    description: 'Una vitrina digital que abre el apetito antes de que te escriban.',
    accent: 'lime',
  },
  {
    imageUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/11a48b0b-c32c-403b-94d9-b88c846607be.jpg',
    alt: 'Concepto de web colorida para servicios profesionales mostrado en teléfono y tablet',
    category: 'Professional services',
    label: 'Confianza en cada pantalla',
    description: 'Información clara y contacto directo desde cualquier dispositivo.',
    accent: 'cobalt',
  },
]

export const EMAIL_ADDRESS = 'byronwebs@outlook.com'
export const EMAIL_URL = `mailto:${EMAIL_ADDRESS}`

const WHATSAPP_NUMBER = '17867291583'
const WHATSAPP_MESSAGE =
  'Hola Maggie, vi tu página y quiero una web que se sienta imposible de ignorar. Te cuento sobre mi negocio.'

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE,
)}`
